export default __webpack_public_path__ + "static/media/menuHead.059d38bc.webp";